<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import classnames from "classnames"
  import { omit } from "$lib/utils/object"

  export let id = Math.random().toString(36).substring(7)
  export let name: string
  export let value: string = ""
  export let label: string
  export let error: string | null | undefined = undefined

  const attributes = omit($$restProps, "class")

  const dispatcher = createEventDispatcher();

  let focused = false;

  const onBlur = () => {
    if (focused) {
      dispatcher('touch', true);
    }
  };

  const onInput = (e: Event) => {
    const input = e.target as HTMLInputElement;
    value = input.value;
    dispatcher('change', value);
  };
</script>

<div class="{classnames('textarea-wrapper', $$props.class)}">
  <textarea
    id="{id}"
    type="textarea"
    class="textarea"
    name="{name}"
    {value}
    on:blur={onBlur}
    on:input={onInput}
    on:focus={() => (focused = true)}
    placeholder="{label}"
    rows="4"
    {...attributes}></textarea>

  {#if error}
    <span class="error">{error}</span>
  {/if}
</div>

<style type="text/scss" lang="scss" scoped>
  .textarea-wrapper {
    @apply flex relative;
    @apply mb-3;
  }

  .textarea {
    @apply w-full;
    @apply appearance-none resize-none;
    @apply outline-none shadow-none focus:outline-none focus:shadow-none focus:ring-0;
    @apply border border-gray-600 focus:border-brand rounded;
    @apply p-4;
    @apply ease-in-out duration-200;
    transition-property: border-color;

    &::placeholder {
      @apply text-gray-600;
    }
  }

  .error {
    @apply absolute -bottom-5 left-4;
    @apply text-xs;
    @apply text-error;
  }
</style>
